const SONG_STATUS = Object.freeze({
  FINISHED: 'finished',
  NOT_STARTED: 'not_started',
  PAUSED: 'paused',
  PLAYING: 'playing',
});

export default SONG_STATUS;
